import { IJsonapiModel, Response } from 'datx-jsonapi';
import { flatten, last } from 'lodash';

import { ICollectionMeta } from '@/interfaces/ICollectionMeta';

export function extractSWRInfiniteDataCursor<T extends IJsonapiModel, Data extends Response<T> = Response<T>>(
  data: Array<Data>,
  error: any,
  size: number
) {
  const isLoadingInitialData = !data && !error;
  const isLoadingMore = isLoadingInitialData || (size > 0 && data && !data[size - 1]);

  const isEmpty = data?.length === 0 || (data?.[0]?.data as Array<T>)?.length === 0;

  const meta = last(data)?.meta as ICollectionMeta;

  const isReachingEnd = isEmpty || !meta?.pageCursor;

  const items = flatten(
    data
      ?.filter((d) => d)
      ?.map((page) => {
        return page.data;
      })
  );

  return {
    isLoadingMore,
    isReachingEnd,
    isEmpty,
    items,
    meta,
  };
}
